import {connect} from 'react-redux';
import {createSubmitAction} from '../../app/forms';
import {FormattedMessage} from 'react-intl';
import Alert from '../../../ui/Alert';
import Page from '../../app/components/Page';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './css/Register.scss';
import RegisterForm from '../forms/Register';
import {push} from 'react-router-redux';

import {
    REGISTER_SUBMIT,
    REGISTER_SUCCESS,
    REGISTER_FAILURE,
} from '../../app/session';


export class Register extends Component {
    static propTypes = {
        children: PropTypes.node,
        redirectRoute: PropTypes.string,
        dispatch: PropTypes.func.isRequired,
    }

    constructor(...args) {
        super(...args);
        this.state = {erroneous: false, successful: false, email: null};
    }

    componentWillMount() {
        const { tenant } = this.props;
        if (this.props.session) {
            if (this.props.session.get('authenticated')) {
                this.props.dispatch(push('/'));
            }
            else if (!tenant || !tenant.get('code_part')) {
                this.props.dispatch(push('/select'));
            }
        }
    }

    handleSubmitSuccess = () => {
        this.setState({successful: true, erroneous: false})
        window.scrollTo(0, 0);
    }

    storeMailAddress = (values) => {
        this.setState({email: values.get('email')})
    }

    handleSubmitFailure = () => {
        this.setState({erroneous: true, successful: false});
        window.scrollTo(0, 0);
    }

    render() {
        const {erroneous, successful, email} = this.state;

        if (successful) {
            return (
                <Page.Body>
                    <h3>
                        <FormattedMessage id='frontend.register_confirmation.headline'/>
                    </h3>
                    <div>
                        <FormattedMessage id='frontend.form_register.confirmation.message' values={{email}}/>
                    </div>
                </Page.Body>
            );
        }
        return (
            <Page.Body>
                <div className={styles.wrapper}>
                    {erroneous && (
                        <Alert type='danger'>
                            <FormattedMessage id='frontend.form_register.message.invalid'/>
                        </Alert>
                    )}
                    <RegisterForm.Component
                        onSubmitFail={this.handleSubmitFailure}
                        onSubmitSuccess={this.handleSubmitSuccess}
                        onSubmit={createSubmitAction(
                            REGISTER_SUBMIT,
                            REGISTER_SUCCESS,
                            REGISTER_FAILURE,
                            (values) => {
                                this.storeMailAddress(values);
                            }
                        )}
                    />
                </div>
            </Page.Body>
        );
    }
}

export default connect((state) => ({
    dispatch: state.dispatch,
    session: state.session,
    tenant: state.tenant,
}))(Register);
